import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout/DashboardLayout';
import RootLayout from '../layouts/RootLayout/RootLayout';
import Dashboard from '../pages/Dashboard/Dashboard';
import DomainRecords from '../pages/DomainRecords/DomainRecords';
import DomainSetup from '../pages/DomainSetup/DomainSetup';
import Home from '../pages/Home/Home';
import NotFound from '../pages/NotFound/NotFound';
import Settings from '../pages/Settings/Settings';
import Contacts from '../pages/Contacts/Contacts';
import ContactForm from '../pages/Contacts/ContactForm';
import ContactsDetails from 'pages/Contacts/ContactsDetails/ContactsDetails';
import UploadCSV from '../pages/Contacts/UploadCSV';
import Segments from 'pages/Segments/segments';
import SmartSegmentsForm from 'pages/Segments/SmartSegments/smartSegmentsform';
import SegmentDetails from 'pages/Segments/SegmentDetails/SegmentDetails';
import ManualSegmentDetails from 'pages/Segments/ManualSegmentDetails/ManualSegmentDetails';
import WorkflowCanvas from 'pages/Workflows/WorkflowCanvas';
import EmailBuilder from 'pages/EmailBuilder/EmailBuilder';
import WorkspaceSettings from 'pages/WorkspaceSettings/WorkspaceSettings';
import AccountSettings from 'pages/AccountSettings/AccountSettings';
import UnsubscribeGroups from 'pages/UnsubscribeGroups/UnsubscribeGroups';
import UnsubscribePreferemceMail from 'pages/UnsubscribePreferemceMail/UnsubscribePreferemceMail';
import CampaignsV2 from 'pages/CampaignsV2/CampaignsV2';
import CampaignBuilder from 'pages/CampaignBuilder/CampaignBuilder';
import ActivityLogs from 'pages/ActivityLogs/ActivityLogs';
import UnsubscribeMail from 'pages/UnsubscribeMail/UnsubscribeMail';
import EmailView from 'pages/EmailView/EmailView';
import DataIntegrations from 'pages/DataIntegrations/DataIntegrations';
import ComingSoon from 'pages/ComingSoon/ComingSoon';
import ApiDocs from 'pages/ApiDocs/ApiDocs';
import UpgradePlans from 'pages/UpgradePlans/UpgradePlans';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<RootLayout />}>
        <Route index element={<Home />} />
        <Route
          path="unsubscribePreferences/:trackingId"
          element={<UnsubscribePreferemceMail />}
        />
        <Route path="unsubscribe/:trackingId" element={<UnsubscribeMail />} />
        <Route element={<DashboardLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          {/* <Route path="campaigns" element={<Campaigns />} /> */}
          <Route path="campaigns" element={<CampaignsV2 />} />
          {/* <Route path="campaigns-v2" element={<CampaignsV2 />} /> */}
          <Route path="analytics" element={<ComingSoon />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="contacts/add" element={<ContactForm />} />
          <Route path="contacts/edit/:id" element={<ContactForm />} />
          <Route path="contacts/upload-csv" element={<UploadCSV />} />
          <Route path="broadcasts" element={<ComingSoon />} />
          <Route path="deliveries" element={<ComingSoon />} />
          <Route path="content" element={<ComingSoon />} />
          {/* <Route path="design-studio" element={<DesignStudioPage />} /> */}
          <Route path="activity-logs" element={<ActivityLogs />} />
          <Route path="data-integrations" element={<DataIntegrations />} />
          {/* <Route path="transactional" element={<TransactionalPage />} /> */}
          {/* <Route path="anonymous" element={<AnonymousPage />} /> */}
          {/* <Route path="custom-objects" element={<CustomObjectsPage />} /> */}
          <Route path="domain-setup" element={<DomainSetup />} />
          <Route
            path="domain-setup/:domainId/records"
            element={<DomainRecords />}
          />
          <Route path="settings" element={<Settings />} />
          <Route path="workspace-settings" element={<WorkspaceSettings />} />
          <Route path="account-settings" element={<AccountSettings />} />
          <Route path="contacts/:id" element={<ContactsDetails />} />
          <Route path="segments" element={<Segments />} />
          <Route path="segments/smart" element={<SmartSegmentsForm />} />
          <Route
            path="segments/smart/edit/:id"
            element={<SmartSegmentsForm />}
          />
          <Route path="segments/smart/:id" element={<SegmentDetails />} />
          <Route
            path="segments/manual/:id"
            element={<ManualSegmentDetails />}
          />
          <Route path="campaigns/workflow/:id" element={<WorkflowCanvas />} />
          <Route path="campaigns/builder/:id" element={<CampaignBuilder />} />
          <Route
            path="campaigns/:campaignId/node/:nodeId/email-builder/:templateId?"
            element={<EmailBuilder />}
          />
          <Route path="unsubscribe-groups" element={<UnsubscribeGroups />} />
          <Route path="emails/view/:id" element={<EmailView />} />
          <Route path="api-docs" element={<ApiDocs />} />
        </Route>

        <Route path="upgrade-plans" element={<UpgradePlans />} />

        {/* Error Routes */}
        <Route path="404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
